import { useState } from 'react';
import Text from '../../components/Text';
import Input from '../../components/Input';
import DropdownV2 from '../../components/Dropdown/DropdownV2';

export default function ContactUsForm() {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        schoolName: '',
        email: '',
        phone: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = () => {
        console.log('Form submitted:', formData);
        alert('Thank you! Check your email for the webinar link.');
        setFormData({
            firstName: '',
            lastName: '',
            schoolName: '',
            email: '',
            phone: ''
        });
    };

    return (
        <div className="bg-[white] flex items-center justify-center p-8 border border-[#E2E8F1] rounded-2xl">
            <div className="space-y-6">
                {/* Full Name */}
                <Input label='Full Name' />

                {/* Institution Name and Last Name Row */}
                <div className="grid grid-cols-2 gap-4">
                    <Input label='Institution Name' />
                    <DropdownV2 label='Your Role' />
                </div>

                {/* Email Address */}
                <Input label='Email Address' />

                {/* Institution Name and Last Name Row */}
                <div className="grid grid-cols-2 gap-4">
                    <Input label='Phone Number' />
                    <DropdownV2 label='City/State' options={[]} />
                </div>

                {/* School Name */}
                <Input label='Message' />

                {/* Submit Button */}
                <button
                    onClick={handleSubmit}
                    className="w-full py-3 px-4 bg-[#4949DE] text-[white] font-semibold rounded-lg hover:from-red-600 hover:to-purple-700 transition-all duration-300 shadow-lg"
                >
                    Send Message
                </button>
            </div>
        </div>
    );
}